var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 310.2451 106.4478",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.2323 21.1281h-4.52l-.0005 38.3665a5.602 5.602 0 0 1 -5.5944 5.5969h-35.9892v4.5172h35.99a10.1258 10.1258 0 0 0 10.1141-10.1141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.2763 33.67h-94.7811a8.54 8.54 0 0 0 -8.5292 8.5311v3.1689a8.539 8.539 0 0 0 8.5292 8.53h34.5907a4.0172 4.0172 0 0 1 4.0129 4.0124v3.1676a4.017 4.017 0 0 1 -4.0129 4.0119h-94.7807a4.0168 4.0168 0 0 1 -4.0124-4.0119v-18.8788a4.017 4.017 0 0 1 4.0124-4.0125h34.5874a4.0173 4.0173 0 0 1 4.0129 4.0125v7.1794h-34.1147v4.5186h38.6338v-11.698a8.6458 8.6458 0 0 0 -8.532-8.5311h-34.5874a8.54 8.54 0 0 0 -8.53 8.5311v18.8788a8.5391 8.5391 0 0 0 8.53 8.5291h94.7807a8.5388 8.5388 0 0 0 8.5291-8.5291v-3.168a8.6443 8.6443 0 0 0 -8.5291-8.531h-34.5907a4.0151 4.0151 0 0 1 -4.01-4.011v-3.1688a4.0158 4.0158 0 0 1 4.01-4.0125h94.7811a4.0172 4.0172 0 0 1 4.0129 4.0125v18.8788a4.0169 4.0169 0 0 1 -4.0129 4.0119l-43.12.0029v20.2252h4.5192v-15.7113h38.6007a8.5389 8.5389 0 0 0 8.5292-8.5291v-18.8784a8.6444 8.6444 0 0 0 -8.5291-8.5312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.3468 42.2012v27.4075h4.5192v-27.4075a4.0157 4.0157 0 0 1 4.01-4.0124h24.241v-4.5188h-24.241a8.54 8.54 0 0 0 -8.5292 8.5312z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f1ac46901bcfcc55466c64c076ec5d8b.svg";
export { ForwardRef as ReactComponent };